import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/** Shared page hierarchy; actions remain owned by each feature page. */
@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() description = '';
}
